<div class="cell-content">
  <sui-button
    [variant]="variant"
    [leadingIcon]="leadingIcon"
    [disabled]="disabled"
    [iconOnly]="iconOnly"
    [ariaLabel]="ariaLabel"
    (click)="click()"
  >
    {{ title }}
  </sui-button>
</div>
